import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FormlyModule } from '@ngx-formly/core';
import { NgxCurrencyDirective } from 'ngx-currency';
import { NgxMaskDirective } from 'ngx-mask';

import {
  ClearOnFocusDirective,
  FormGroupValidationDirective,
  LAValidators,
} from '@lockton-apps/shared/util/form-utils';

import { PasswordFieldTypeComponent } from './password-field-type.component';
import { PasswordRequirementsComponent } from '@lockton-apps/auth/ui/password-requirements';
import { FormFieldModule } from '@lockton-apps/shared/ui/lui';

@NgModule({
  declarations: [PasswordFieldTypeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    PasswordRequirementsComponent,
    FormFieldModule,
    FormGroupValidationDirective,
    FormlyModule.forChild({
      types: [
        {
          name: 'password',
          component: PasswordFieldTypeComponent,
          defaultOptions: {
            props: {
              label: 'Password',
              withHelper: true,
              required: true,
            },
            validators: [
              'lowercaseChars',
              'uppercaseChars',
              'numberChars',
              'specialChars',
              'noSpaces',
            ],
          },
        },
        {
          name: 'confirmPassword',
          extends: 'password',
          defaultOptions: {
            props: {
              label: 'Confirm Password',
              withHelper: false,
              required: true,
            },
            validators: [],
          },
        },
      ],
    }),
    ClearOnFocusDirective,
  ],
})
export class PasswordFieldTypeModule {}
